import { Percent } from '../../atoms/percent'
import { StyledAssetTable } from './primitives'

type Statistic = {
  maxDrawdown: number
  period: string
  return: number
  sharpe: number
  volatility: number
}

export type StatisticsTableProps = {
  statistics?: Statistic[]
}

export function StatisticsTable({ statistics }: StatisticsTableProps) {
  return (
    <StyledAssetTable>
      <thead>
        <tr>
          <th className="period">Period</th>
          <th className="return">Return</th>
          <th className="volatility">Volatility</th>
          <th className="max-drawdown">Max drawdown</th>
          <th className="sharpe">Sharpe ratio</th>
        </tr>
      </thead>
      <tbody>
        {Array.isArray(statistics) &&
          statistics.map(stat => (
            <tr key={stat.period}>
              <td className="period">{stat.period}</td>
              <td className="return">
                <Percent
                  fixed
                  highlightPnl
                  numDecimalPlaces={2}
                  value={stat.return === null ? null : stat.return * 100}
                />
              </td>
              <td className="volatility">
                <Percent
                  fixed
                  highlightPnl={false}
                  numDecimalPlaces={2}
                  value={stat.volatility === null ? null : stat.volatility * 100}
                />
              </td>
              <td className="max-drawdown">
                <Percent
                  fixed
                  highlightPnl={false}
                  numDecimalPlaces={2}
                  value={stat.maxDrawdown === null ? null : stat.maxDrawdown * 100}
                />
              </td>
              <td className="sharpe">{stat.sharpe === null ? '-' : stat.sharpe.toFixed(4)}</td>
            </tr>
          ))}
      </tbody>
    </StyledAssetTable>
  )
}
